<template lang="html">
  <h1>Entschuldigen Sie. Leider ist ein Fehler aufgetreten.</h1>
</template>

<script>
export default {
  name: 'Error'
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Error.vue